$(document).ready(function(){

    $(document).on("click",".header__icon--menu",function() {
      $('html').toggleClass('overflow_hidden');
    });
  
    $('.md_ugcs_next').click(function(){
        var currentIndex = parseFloat($('.md_ugcs_popup_outer.active').attr('data-index'));
        currentIndex++;
        var videosMax = 0;
        $('.md_ugc_video_popup').each(function(){
            videosMax ++;
        });
        videosMax = videosMax / 2;
        console.log(currentIndex, videosMax, ' current indec');
         $('.md_ugcs_popup_outer').find('video').each(function() {
            this.pause(); 
            // this.currentTime = 0;
        });
        $('.md_ugcs_play_icon').hide();
        if (currentIndex <= videosMax ){
            $('.md_ugcs_popup_outer').hide();
            $('.md_ugcs_popup_outer[data-index="'+currentIndex+'"]').css('display', 'flex');
            $('.md_ugcs_popup_outer').removeClass('active');
            $('.md_ugcs_popup_outer[data-index="'+currentIndex+'"]').addClass('active');
            var video = $('.md_ugcs_popup_outer[data-index="'+currentIndex+'"]').find('.md_ugcs_popup_video')[0];
            video.play();
            $('.md_ugcs_muted').hide();
            $('.md_ugcs_unmuted').show();
            video.muted = false;
        }

        var $video = $(video);
        const $progress = $('.timeline').find('.progress');
        const $timeline = $('.timeline');
  
        $video.on('timeupdate', function() {
            const currentTime = $video[0].currentTime;
            const duration = $video[0].duration;
            const progressWidth = (currentTime / duration) * 100;
            $progress.css('width', progressWidth + '%');
        });
    });

    $('.md_ugcs_prev').click(function(){
        var currentIndex = parseFloat($('.md_ugcs_popup_outer.active').attr('data-index'));
        if (currentIndex > 1){
            currentIndex--;
        }
        
        console.log(currentIndex, ' current indec');
        $('.md_ugcs_popup_outer').find('video').each(function() {
            this.pause(); 
            // this.currentTime = 0;
        });
        $('.md_ugcs_play_icon').hide();
        if (currentIndex > 0){
            $('.md_ugcs_popup_outer').hide();
            $('.md_ugcs_popup_outer[data-index="'+currentIndex+'"]').css('display', 'flex');
            $('.md_ugcs_popup_outer').removeClass('active');
            $('.md_ugcs_popup_outer[data-index="'+currentIndex+'"]').addClass('active');
            var video = $('.md_ugcs_popup_outer[data-index="'+currentIndex+'"]').find('.md_ugcs_popup_video')[0];
            video.play();
            $('.md_ugcs_muted').hide();
            $('.md_ugcs_unmuted').show();
            video.muted = false;
        }

        var $video = $(video);
        const $progress = $('.timeline').find('.progress');
        const $timeline = $('.timeline');
  
        $video.on('timeupdate', function() {
            const currentTime = $video[0].currentTime;
            const duration = $video[0].duration;
            const progressWidth = (currentTime / duration) * 100;
            $progress.css('width', progressWidth + '%');
        });
        
    });

    $('.mg_ugc_video_play').click(function(){
        $('.mg_ugc_video_play').show();
        $('.md_ugc_cell_info').show();
        $('.md_ugcs_poster_outside').show();
        $(this).hide();
        $('.mg_ugc_video_pause').hide();
        $(this).closest('.md_ugc_cell').find('.mg_ugc_video_pause').show();
        var video = $(this).parent('.md_ugc_video_out').find('video')[0];
        $(this).closest('.md_ugc_cell').find('.md_ugc_cell_info').hide();

        $('.md_ugc_cell').find('video').each(function() {
            this.pause(); 
            // this.currentTime = 0;
        });
          
        if (video) {
            video.muted = false;
            video.play();
            $(this).closest('.md_ugc_video_out').find('.md_ugcs_poster_outside').hide();
        }
    });

    $('.mg_ugc_video_pause').click(function(){
        $('.mg_ugc_video_play').show();
        $('.md_ugc_cell_info').show();
        $('.mg_ugc_video_pause').hide();
        $('.md_ugcs_poster_outside').show();
        var video = $(this).parent('.md_ugc_video_out').find('video')[0];
        $(this).closest('.md_ugc_cell').find('.md_ugc_cell_info').show();

        $('.md_ugc_cell').find('video').each(function() {
            this.pause(); 
            // this.currentTime = 0;
        });
          
        if (video) {
            video.pause();
        }
    });

  // Loading for safari
    setTimeout(function(){
       $(".video_ugc").each(function() {
            var videoElement = $(this)[0]; // Get the raw DOM element from the jQuery object
            if (videoElement) {
                // Use a promise-based approach to handle play/pause sequence
                var playPromise = videoElement.play();
                
                // If play() returns a promise (modern browsers)
                if (playPromise !== undefined) {
                    playPromise.then(function() {
                        // Play successful, now we can pause safely
                        setTimeout(function() {
                            videoElement.pause();
                        }, 100);
                    }).catch(function(error) {
                        // Play was prevented (autoplay policy, etc)
                        console.log("Play prevented:", error);
                    });
                } else {
                    // Older browsers might not return a promise
                    setTimeout(function() {
                        videoElement.pause();
                    }, 100);
                }
            }
      });
    }, 100);
});